import React from "react";
import Skeleton from "../shared/skeleton-component";

const FieldSkeleton = () => {
  return (
    <>
      <Skeleton width="100%" height="50px" />
    </>
  );
};

export default FieldSkeleton;
